import { Surface } from './surface/surface'

import * as def from '@/definitions'
import { Frame } from '../frame/frame';

// ページ
export class Page
{
    // 面
    // 0: 表面
    // 1: 裏面
    private _surfaces : Surface[] = new Array();
    public get surfaces() { return this._surfaces; }
    public getSurface(isReverse = false) 
    {
        var index = this.hasReverse && isReverse ? 1 : 0; 
        return this._surfaces[index];
    }
    public addSurface(surface) { this._surfaces.push(surface); }
    // 裏面があるかどうか
    public get hasReverse() { return this._surfaces.length == 2; }

    // 面あたりのデザインの最大配置数
    public designMaxNumber : number = 0;

    // カレントデザインインデックス
    private _currentDesignPosition : number = 0;
    public get currentDesignPosition() { return this._currentDesignPosition; }
    public set currentDesignPosition(currentDesignPosition : number) { this._currentDesignPosition = currentDesignPosition; }

    // ページ幅
    private _width : number = 0;
    public get width() : number { return this._width; }
    public set width(width : number) { this._width = width; }
    // ページ高さ
    private _height : number = 0;
    public get height() : number { return this._height; }
    public set height(height : number) { this._height = height; }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            width : this.width,
            height : this.height,
            designMaxNumber : this.designMaxNumber,
            surfaces : this.surfaces
        };

        return cloneObj;
    }

    public static create(width : number, height : number, frameArray : Array<Frame>, hasReverseSurface : boolean = false, rotate = 0)
    {
        var page = new Page()

        // サイズ設定
        page.width = width;
        page.height = height;

        // デザイン数
        var designMaxNumber = 0;
        for(var frame of frameArray)
        {
            designMaxNumber += frame.row * frame.col;
        }
        page.designMaxNumber = designMaxNumber;

        // 表面を作成する
        page.addSurface(Surface.create(width, height, frameArray, false, rotate));
        if(hasReverseSurface)
        {
            // 裏面を作成する
            page.addSurface(Surface.create(width, height, frameArray, true, rotate));
        }
        
        return page;
    }

    public static createFromJsonData(jsonData : any)
    {
        var page = new Page();
        if(jsonData.width) { page.width = jsonData.width; }
        if(jsonData.height) { page.height = jsonData.height; }
        if(jsonData.designMaxNumber) { page.designMaxNumber = jsonData.designMaxNumber; }
        if(jsonData.surfaces) 
        { 
            for(var i = 0; i < jsonData.surfaces.length; ++i)
            {
                page.addSurface(Surface.createFromJsonData(jsonData.surfaces[i]));
            }
        }

        return page;
    }

    // エラーチェック
    public hasError()
    {
        var error = false;
        for(var i = 0; i < this._surfaces.length; ++i)
        {
            var surface = this._surfaces[i];
            if(surface.hasError())
            {
                error = true;
                break;
            }
        }

        return error;
    }
}